import PreviousOrders from 'components/PreviousOrders';
import withOrderSearch from 'hoc/withOrderSearch';
import { actions, selectors } from 'modules/orderSearch';

const mapState = state => ({
  hasSearched: selectors.hasSearched(state),
  orders: selectors.orders(state),
  loading: selectors.loading(state),
  error: selectors.error(state),
});

const mapDispatch = {
  fetchResults: actions.requestAction,
};

export default withOrderSearch(mapState, mapDispatch)(PreviousOrders);
